import type { SagaReturnType } from 'redux-saga/effects';
import { select, takeLatest } from 'redux-saga/effects';
import { getUserId } from 'src/utils/getUserId';
import { api } from 'src/api';
import type { postStatsExperimentRequest } from '@lt/api/dist/methods/stats/types';
import { APPLICATION_VERSION } from 'src/error/config/sentry/runTimeConfig';
import { getClient, getClientStatsData } from '../client/selectors';
import { getIsMobile, searchTypeSelector } from '../view/selectors';
import { sendExperimentResultAction } from './actions';

function* handleSendExperimentData(
  action: ReturnType<typeof sendExperimentResultAction>,
) {
  const searchType: SagaReturnType<typeof searchTypeSelector> = yield select(
    searchTypeSelector,
  );
  const { experiment, event } = action.payload;
  const isClientStoreAvailable = Boolean(yield select(getClient));
  const clientData: SagaReturnType<typeof getClientStatsData> =
    isClientStoreAvailable
      ? yield select(getClientStatsData)
      : { uuid: getUserId() };
  const isMobile: SagaReturnType<typeof getIsMobile> = yield select(
    getIsMobile,
  );
  const partnerId = window.PARTNER ? window.PARTNER.id : null;
  const data: postStatsExperimentRequest = {
    search_type: searchType,
    url: window.location.href,
    client: clientData,
    is_mobile: isMobile,
    release_version: APPLICATION_VERSION ?? '',
    partner_id: partnerId,
    experiment,
    event,
  };
  try {
    yield api.postStatsExperiment(data);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export default function* experimentSaga() {
  yield takeLatest(sendExperimentResultAction, handleSendExperimentData);
}
